import { connectionActions } from "./connectionActions";

export const rootActions = {
    connection: connectionActions
}
